import type { SVGProps } from 'react';
const DawnFlagGI = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GI_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GI_svg__a)">
      <path fill="#E34F4F" d="M0 16h22v-5.333H0zM7.333 10.667h6.286V6.4H7.333z" />
      <path
        fill="#181A1A"
        d="M8.38 10.667h1.048V9.6H8.381zM11.523 10.667h1.048V9.6h-1.048zM7.333 6.4h1.048V5.333H7.333zM10.477 6.4h1.047V5.333h-1.047zM9.429 6.4h1.047V5.333H9.43zM12.571 6.4h1.048V5.333H12.57z"
      />
      <path
        fill="#E34F4F"
        d="M7.333 5.333h1.048V4.267H7.333zM10.477 5.333h1.047V4.267h-1.047zM9.429 5.333h1.047V4.267H9.43zM12.571 5.333h1.048V4.267H12.57z"
      />
    </g>
  </svg>
);
export default DawnFlagGI;
